export default __webpack_public_path__ + "static/button-decoration-dont-light-c873737204f0ba4ddb47d833a2927434.png";